(function() {
    // Initialize dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];
    
    // Push calculator started event
    window.dataLayer.push({
        'event': 'calculator_started',
        'calculator_name': 'pool_heating_savings',
        'calculator_version': 'quiz_v1'
    });
    
    // Quiz state
    let currentStep = 1;
    const totalSteps = 5;
    
    const quizData = {
        heaterType: 'gas',
        poolLength: 20,
        poolWidth: 40,
        shallowDepth: 3.5,
        deepDepth: 6.5,
        desiredTemp: 82,
        swimMonths: 8,
        coverUsage: 0
    };
    
    // OASIS Calculation Config
    const ORLANDO_CONFIG = {
        electricRate: 0.14,
        gasRate: 1.50,
        propaneRate: 3.50,
        heatPumpCOP: 6.5,
        heatPumpBTUhr: 130000,
        gasHeaterBTUhr: 400000,
        gasEfficiency: 0.82,
        kwhToBtu: 3412,
        thermToBtu: 100000,
        propaneBtuPerGallon: 91500,
        avgDailyHeatHours: 3,
        coverMultipliers: {
            0.5: 0.40,
            0.3: 0.55,
            0: 1.0
        }
    };
    
    // Update progress bar
    function updateProgress() {
        const percent = (currentStep / totalSteps) * 100;
        document.querySelector('.progress-bar::before') || 
        document.querySelector('.progress-bar').style.setProperty('--progress', percent + '%');
        
        const style = document.createElement('style');
        style.innerHTML = `.progress-bar::before { width: ${percent}% !important; }`;
        document.head.appendChild(style);
        
        // Update step indicators
        document.querySelectorAll('.progress-step').forEach((step, index) => {
            const stepNum = index + 1;
            step.classList.remove('active', 'completed');
            if (stepNum < currentStep) {
                step.classList.add('completed');
            } else if (stepNum === currentStep) {
                step.classList.add('active');
            }
        });
    }
    
    // Navigation
    window.nextStep = function() {
        if (currentStep < totalSteps) {
            document.querySelector(`.quiz-step[data-step="${currentStep}"]`).classList.remove('active');
            currentStep++;
            document.querySelector(`.quiz-step[data-step="${currentStep}"]`).classList.add('active');
            updateProgress();
            
            // Track step progression
            window.dataLayer.push({
                'event': 'calculator_step_completed',
                'step_number': currentStep - 1,
                'step_name': getStepName(currentStep - 1)
            });
            
            window.dataLayer.push({
                'event': 'calculator_step_viewed',
                'step_number': currentStep,
                'step_name': getStepName(currentStep)
            });
        }
    };
    
    window.prevStep = function() {
        if (currentStep > 1) {
            document.querySelector(`.quiz-step[data-step="${currentStep}"]`).classList.remove('active');
            currentStep--;
            document.querySelector(`.quiz-step[data-step="${currentStep}"]`).classList.add('active');
            updateProgress();
            
            // Track back button
            window.dataLayer.push({
                'event': 'calculator_step_back',
                'from_step': currentStep + 1,
                'to_step': currentStep
            });
        }
    };
    
    // Helper function to get step names
    function getStepName(stepNum) {
        const stepNames = {
            1: 'heater_type',
            2: 'pool_dimensions',
            3: 'desired_temperature',
            4: 'heating_months',
            5: 'pool_cover'
        };
        return stepNames[stepNum] || 'unknown';
    }
    
    // Step 1: Heater Type
    window.selectHeaterType = function(type) {
        quizData.heaterType = type;
        
        // Track heater type selection
        window.dataLayer.push({
            'event': 'calculator_heater_selected',
            'heater_type': type,
            'step_number': 1
        });
        
        setTimeout(() => nextStep(), 300);
    };
    
    // Step 2: Dimensions
    window.updateDimension = function(type) {
        if (type === 'length') {
            quizData.poolLength = document.getElementById('poolLength').value;
            document.getElementById('lengthValue').textContent = quizData.poolLength;
        } else if (type === 'width') {
            quizData.poolWidth = document.getElementById('poolWidth').value;
            document.getElementById('widthValue').textContent = quizData.poolWidth;
        } else if (type === 'shallow') {
            quizData.shallowDepth = document.getElementById('shallowDepth').value;
            document.getElementById('shallowValue').textContent = quizData.shallowDepth;
        } else if (type === 'deep') {
            quizData.deepDepth = document.getElementById('deepDepth').value;
            document.getElementById('deepValue').textContent = quizData.deepDepth;
        }
        
        // Update gallons preview
        const avgDepth = (parseFloat(quizData.shallowDepth) + parseFloat(quizData.deepDepth)) / 2;
        const gallons = quizData.poolLength * quizData.poolWidth * avgDepth * 7.48;
        document.getElementById('gallonsPreview').textContent = Math.round(gallons).toLocaleString();
    };
    
    // Step 3: Temperature
    window.updateTemperature = function() {
        quizData.desiredTemp = document.getElementById('desiredTemp').value;
        document.getElementById('tempDisplay').textContent = quizData.desiredTemp;
    };
    
    // Step 4: Months
    window.selectMonths = function(months) {
        quizData.swimMonths = months;
        document.querySelectorAll('.month-choice').forEach(btn => btn.classList.remove('selected'));
        document.querySelector(`.month-choice[data-months="${months}"]`).classList.add('selected');
        
        // Track months selection
        window.dataLayer.push({
            'event': 'calculator_months_selected',
            'heating_months': months,
            'step_number': 4
        });
    };
    
    // Step 5: Cover
    window.selectCover = function(cover) {
        quizData.coverUsage = cover;
        document.querySelectorAll('.cover-choice').forEach(btn => btn.classList.remove('selected'));
        document.querySelector(`.cover-choice[data-cover="${cover}"]`).classList.add('selected');
        
        // Track cover selection
        const coverTypes = {
            0: 'no_cover',
            0.3: 'solar_blanket',
            0.5: 'automatic_cover'
        };
        
        window.dataLayer.push({
            'event': 'calculator_cover_selected',
            'cover_type': coverTypes[cover],
            'step_number': 5
        });
    };
    
    // Calculate and show results
    window.calculateAndShowResults = function() {
        const avgDepth = (parseFloat(quizData.shallowDepth) + parseFloat(quizData.deepDepth)) / 2;
        const squareFeet = quizData.poolLength * quizData.poolWidth;
        const gallons = squareFeet * avgDepth * 7.48;
        
        const heatingSeasonDays = Math.min(quizData.swimMonths * 22.5, 270);
        const coverMultiplier = ORLANDO_CONFIG.coverMultipliers[quizData.coverUsage] || 1.0;
        const sizeMultiplier = gallons / 20000;
        const tempMultiplier = (quizData.desiredTemp - 78) * 0.15 + 1;
        
        const dailyHeatHours = ORLANDO_CONFIG.avgDailyHeatHours * sizeMultiplier * tempMultiplier * coverMultiplier;
        const annualHeatPumpHours = dailyHeatHours * heatingSeasonDays;
        
        // Electric
        const kwhPerHour = ORLANDO_CONFIG.heatPumpBTUhr / (ORLANDO_CONFIG.kwhToBtu * ORLANDO_CONFIG.heatPumpCOP);
        const electricCostPerHour = kwhPerHour * ORLANDO_CONFIG.electricRate;
        const electricCost = electricCostPerHour * annualHeatPumpHours;
        
        // Gas
        const gasHeatHours = annualHeatPumpHours * (ORLANDO_CONFIG.heatPumpBTUhr / ORLANDO_CONFIG.gasHeaterBTUhr);
        const thermsPerHour = ORLANDO_CONFIG.gasHeaterBTUhr / (ORLANDO_CONFIG.thermToBtu * ORLANDO_CONFIG.gasEfficiency);
        const gasCostPerHour = thermsPerHour * ORLANDO_CONFIG.gasRate;
        const gasCost = gasCostPerHour * gasHeatHours;
        
        // Propane
        const propaneGallonsPerHour = ORLANDO_CONFIG.gasHeaterBTUhr / (ORLANDO_CONFIG.propaneBtuPerGallon * ORLANDO_CONFIG.gasEfficiency);
        const propaneCostPerHour = propaneGallonsPerHour * ORLANDO_CONFIG.propaneRate;
        const propaneCost = propaneCostPerHour * gasHeatHours;
        
        // Show/hide cards
        const gasCard = document.getElementById('gasCard');
        const propaneCard = document.getElementById('propaneCard');
        
        let comparisonCost, comparisonLabel;
        if (quizData.heaterType === 'gas') {
            gasCard.style.display = 'block';
            propaneCard.style.display = 'none';
            comparisonCost = gasCost;
            comparisonLabel = 'Natural Gas';
        } else if (quizData.heaterType === 'propane') {
            gasCard.style.display = 'none';
            propaneCard.style.display = 'block';
            comparisonCost = propaneCost;
            comparisonLabel = 'Propane';
        } else {
            gasCard.style.display = 'block';
            propaneCard.style.display = 'block';
            comparisonCost = Math.max(gasCost, propaneCost);
            comparisonLabel = propaneCost > gasCost ? 'Propane' : 'Natural Gas';
        }
        
        const savingsAmount = comparisonCost - electricCost;
        const savingsPercent = Math.round((savingsAmount / comparisonCost) * 100);
        
        // Product Recommendation Logic
        let productData;
        if (gallons < 20000) {
            // ME125 for pools under 20k gallons
            productData = {
                name: 'OASIS ME125 Heat Pump',
                image: 'https://oasispoolheaters.com/cdn/shop/files/Oasis_-_Heat_Pump_-_ME125.png?v=1761939377&width=1200&t=' + Date.now(),
                btu: '118,000 BTU',
                cop: '6.1 COP',
                price: '$3,599.95',
                url: 'https://oasispoolheaters.com/products/me125-pool-heater?variant=42092889145406'
            };
        } else {
            // ME140 for pools 20k+ gallons
            productData = {
                name: 'OASIS ME140 Heat Pump',
                image: 'https://oasispoolheaters.com/cdn/shop/files/Oasis_-_Heat_Pump_-_ME140.png?v=1761938933&width=1200&t=' + Date.now(),
                btu: '143,000 BTU',
                cop: '6.0 COP',
                price: '$4,499.95',
                url: 'https://oasispoolheaters.com/products/me140-pool-heater?variant=42092931907646'
            };
        }
        
        // Display results
        document.getElementById('poolSizeResult').textContent = Math.round(gallons).toLocaleString();
        document.getElementById('electricCost').textContent = Math.round(electricCost).toLocaleString();
        document.getElementById('gasCost').textContent = Math.round(gasCost).toLocaleString();
        document.getElementById('propaneCost').textContent = Math.round(propaneCost).toLocaleString();
        document.getElementById('savingsAmount').textContent = Math.round(savingsAmount).toLocaleString();
        document.getElementById('savingsPercent').textContent = savingsPercent;
        document.getElementById('comparisonType').textContent = comparisonLabel;
        
        // Populate product recommendation
        document.getElementById('poolSizeRec').textContent = Math.round(gallons).toLocaleString();
        document.getElementById('productName').textContent = productData.name;
        document.getElementById('productImage').src = productData.image;
        document.getElementById('productImage').alt = productData.name;
        document.getElementById('productImageLink').href = productData.url;
        document.getElementById('productBTU').textContent = productData.btu;
        document.getElementById('productCOP').textContent = productData.cop;
        document.getElementById('productPrice').textContent = productData.price;
        document.getElementById('productCTA').href = productData.url;
        document.getElementById('financingLink').href = productData.url;
        
        // Track calculator completion and results
        window.dataLayer.push({
            'event': 'calculator_completed',
            'pool_size_gallons': Math.round(gallons),
            'heater_type': quizData.heaterType,
            'desired_temp': quizData.desiredTemp,
            'heating_months': quizData.swimMonths,
            'cover_type': quizData.coverUsage === 0 ? 'no_cover' : (quizData.coverUsage === 0.3 ? 'solar_blanket' : 'automatic_cover'),
            'annual_electric_cost': Math.round(electricCost),
            'annual_gas_cost': Math.round(gasCost),
            'annual_propane_cost': Math.round(propaneCost),
            'annual_savings': Math.round(savingsAmount),
            'savings_percent': savingsPercent,
            'comparison_type': comparisonLabel
        });
        
        // Track product recommendation
        window.dataLayer.push({
            'event': 'product_recommended',
            'product_name': productData.name,
            'product_model': gallons < 20000 ? 'ME125' : 'ME140',
            'product_price': productData.price,
            'product_btu': productData.btu,
            'product_url': productData.url,
            'recommendation_basis': gallons < 20000 ? 'under_20k_gallons' : 'over_20k_gallons'
        });
        
        // Show results step
        document.querySelector(`.quiz-step[data-step="${currentStep}"]`).classList.remove('active');
        currentStep = 6;
        document.querySelector(`.quiz-step[data-step="6"]`).classList.add('active');
        
        // Update progress to 100%
        const style = document.createElement('style');
        style.innerHTML = `.progress-bar::before { width: 100% !important; }`;
        document.head.appendChild(style);
        
        document.querySelectorAll('.progress-step').forEach(step => {
            step.classList.remove('active');
            step.classList.add('completed');
        });
    };
    
    // Initialize
    updateProgress();
    
    // Add click tracking for CTAs after page loads
    document.addEventListener('DOMContentLoaded', function() {
        // Track View Product CTA clicks
        const productCTA = document.getElementById('productCTA');
        if (productCTA) {
            productCTA.addEventListener('click', function() {
                window.dataLayer.push({
                    'event': 'cta_clicked',
                    'cta_type': 'view_product',
                    'button_text': 'View Your Recommended Heat Pump'
                });
            });
        }
        
        // Track all elements with data-track-event attribute
        document.querySelectorAll('[data-track-event]').forEach(function(element) {
            element.addEventListener('click', function() {
                const eventType = this.getAttribute('data-track-event');
                
                if (eventType === 'call_now') {
                    window.dataLayer.push({
                        'event': 'cta_clicked',
                        'cta_type': 'call_now',
                        'phone_number': '407-809-1454'
                    });
                } else if (eventType === 'financing') {
                    window.dataLayer.push({
                        'event': 'financing_clicked',
                        'link_text': 'See plans'
                    });
                }
            });
        });
    });
})();